import React from 'react';
import Baumumfang from '../components/Baumumfang';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BaumumfangMuerzzuschlag() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="baumumfang-muerzzuschlag-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="baumumfang-muerzzuschlag-heading">BAUMUMFANG</h1>
        </div>

        <Baumumfang ort="muerzzuschlag" />
      </div>
    </div>
  );
}

export default BaumumfangMuerzzuschlag;
